import type { DocumentProcessingResult, IdentityFormData } from "@/screen/Identities/Interfaces/IdentityFormInterfaces";

type IdentityDocumentAttachments = Pick<IdentityFormData, "idFront" | "idBack">;

// En edición el evento de documento se reemite sin adjuntos cada vez que cambian las props derivadas
// de formData, así que una preview vacía conserva lo que ya hubiera en lugar de borrarlo.
export function resolveDocumentAttachments(result: DocumentProcessingResult, frontPreview: string, backPreview: string, current: IdentityDocumentAttachments): IdentityDocumentAttachments
{
    return{
        idFront: result.idFrontFile ?? (frontPreview || current.idFront),
        idBack: result.idBackFile ?? (backPreview || current.idBack),
    };
}
